<template>
    <el-container>
        <el-header style="padding: 0; padding-left: 0px; height: 15px; ">
            <el-popover
                ref="popover4"
                placement="bottom-start"
                width="100"
                trigger="click">
                <el-checkbox-group v-model="checkList" style="width: 100px;" @change="searchChange">
                    <el-checkbox label="userName"  disabled>用户名</el-checkbox><br>
                    <el-checkbox label="phone" >手机号</el-checkbox><br>
                    <el-checkbox label="realName" >姓名</el-checkbox><br>
                    <el-checkbox label="email" >邮箱</el-checkbox><br>
                    <el-checkbox label="qq" >QQ</el-checkbox><br>
                    <el-checkbox label="orgCode">组织机构</el-checkbox><br>
                    <el-checkbox label="originSource" >生源</el-checkbox><br>
                    <el-checkbox label="source" >来源</el-checkbox><br>
                    <el-checkbox label="banch" >批次</el-checkbox><br>
                    <el-checkbox label="status" >状态</el-checkbox><br>
                    <el-checkbox label="createTime" >注册日期</el-checkbox><br>
                </el-checkbox-group>
            </el-popover>
            <el-button type="text" style="padding: 0; margin: 0;float: right; margin-right: 150px" v-popover:popover4>搜索设置</el-button>
        </el-header>
        <el-dialog
            :title="title"
            :visible.sync="addStaff"
            width="45%"
            :close-on-click-modal=false
            :before-close="handleDialogClose"
        >
            <el-form
                ref="staffForm"
                :model="form"
                :rules="rules"
                label-width="120px"
                class="demo-ruleForm"
                align="left"
            >
                <el-form-item label="所属机构" prop="orgCode" v-if="orgType == 1">
                    <el-select
                        placeholder="所属机构"
                        v-model="form.orgCode"
                        @change="changeOrgAdd"
                        style="margin-right: 10px; width: 100%"
                    >
                        <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="用户名:" prop="userName" >
                            <el-input
                                v-model="form.userName"
                                :disabled="isUpdate"
                                placeholder="用户名"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="密码:" prop="password" v-if="!isUpdate">
                            <el-input
                                type="password"
                                v-model="form.password"
                                placeholder="选填，长度6-16，必须包含英文和数字"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
               <el-row>
                   <el-col :span="10">
                       <el-form-item label="姓名:" prop="realName">
                           <el-input v-model="form.realName" placeholder="姓名"></el-input>
                       </el-form-item>
                   </el-col>
                   <el-col :span="10">
                       <el-form-item label="手机号:" prop="phone" >
                           <el-input v-model="form.phone" placeholder="格式为：+区号-手机号"></el-input>
                       </el-form-item>
                   </el-col>
               </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="性别" prop="sex">
                            <el-select v-model="form.sex" placeholder="性别"  style="width: 100%">
                                <el-option label="女" :value="1"></el-option>
                                <el-option label="男" :value="2"></el-option>
                                <el-option label="保密" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="学历:" prop="education">
                            <el-select
                                v-model="form.education"
                                clearable
                                placeholder="学历"
                                style="width: 100%"
                            >
                                <el-option label="高中" value="高中"></el-option>
                                <el-option label="中专" value="中专"></el-option>
                                <el-option label="职高" value="职高"></el-option>
                                <el-option label="大专，高职" value="大专，高职"></el-option>
                                <el-option label="本科" value="本科"></el-option>
                                <el-option label="硕士" value="硕士"></el-option>
                                <el-option label="博士" value="博士"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="loginOrgCode == 'blcuonline'">
                    <el-col :span="10">
                        <el-form-item label="生日" prop="birthday">
                            <el-date-picker
                                v-model="form.birthday"
                                type="date"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="国籍:" prop="nationality">
                            <el-select
                                v-model="form.nationality"
                                clearable
                                filterable
                                placeholder="国籍"
                                style="width: 100%"
            
                            >
                                <el-option v-for="a in nationalityList" :label="a.zhName" :value="a.nationalityId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10" >
                        <el-form-item label="邮箱:" prop="email" >
                            <el-input v-model="form.email" placeholder="邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="QQ:" prop="qq">
                            <el-input v-model="form.qq" placeholder="QQ"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="所在省" prop="province">
                            <el-row>
                                <el-col :span="7">
                                    <el-select
                                        v-model="form.province"
                                        clearable
                                        placeholder="省"
                                        style="width: 100%"
                                        @change="changeProvince"
                                    >
                                        <el-option v-for="a in area" :label="a.name" :value="a.code"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col class="line" :span="2">市</el-col>
                                <el-col :span="7">
                                    <el-select
                                        v-model="form.city"
                                        clearable
                                        placeholder="市"
                                        style="width: 100%"
                                        @change="changeCity"
                                    >
                                        <el-option v-for="a in city" :label="a.name" :value="a.code"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col class="line" :span="1">区</el-col>
                                <el-col :span="7">
                                    <el-select
                                        v-model="form.district"
                                        clearable
                                        placeholder="区"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="a in district" :label="a.name" :value="a.code"></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="护照名:" prop="passportFirstName" >
                            <el-input v-model="form.passportFirstName" placeholder="护照名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="护照姓:" prop="passportLastName">
                            <el-input v-model="form.passportLastName" placeholder="护照姓"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="现居地:" prop="address">
                            <el-input v-model="form.address" placeholder="现居地"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="生源:" prop="address">
                            <el-select
                                v-model="form.originSource"
                                clearable
                                placeholder="生源"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in agentsList"
                                    :key="item.agentCode"
                                    :label="item.agentDes"
                                    :value="item.agentCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveStaff('staffForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="导入"
            :visible.sync="showImport"
            width="30%"
            :close-on-click-modal=false
            :before-close="handleStudentClose"
        >
            <el-form
                ref="importStudentForm"
                :model="importStudentForm"
                :rules="rulesImpoort"
                label-width="120px"
                class="demo-ruleForm"
                align="left"
            >
                <el-form-item label="所属机构：" prop="orgCode" v-if="orgType == 1">
                    <el-select
                        placeholder="所属机构"
                        size="small"
                        v-model="importStudentForm.orgCode"
                        style="margin-right: 10px; width: 100%"
                        @change="changeImportOrgCode"
                    >
                        <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="批次：" prop="banch">
                    <el-input  v-model="importStudentForm.banch" size="small" ></el-input>
                </el-form-item>
                <el-form-item label="上传文件：" prop="file">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadUrl"
                        accept=".xlsx, .xls"
                        :file-list="fileList"
                        :on-remove="removeFile"
                        :on-change="selectUploadfile"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :auto-upload="false"
                        :data="importStudentForm"
                        :before-upload="beforeAvatarUpload"
                        :limit="1"
                        :headers="headerData"
                    >
                        <el-button
                            slot="trigger"
                            size="small"
                            type="primary"
                            v-show="isShowChooseBtn"
                        >选择文件</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="格式要求：">
                    <div>.xlsx，.xls</div>
                </el-form-item>
                <el-form-item label="模板下载：">
                    <a
                        href="https://www.eblcu.com/media/excelTemplate/1596011533860-static.xlsx"
                    >excel导入模板.xls</a>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitImport('importStudentForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="用户详情"
            :visible.sync="detailDialog.show"
            width="30%"
            :close-on-click-modal=false
            :before-close="handleDetailClose"
            id="detailDialog"
        >
            <el-form class="demo-ruleForm" align="left" label-width="100px">
                <el-form-item
                    label="所属机构："
                    prop="orgName"
                    v-if="orgType == 1"
                >{{detailDialog.data.orgName}}</el-form-item>
                <el-form-item label="用户名：" prop="userName">{{detailDialog.data.userName}}</el-form-item>
                <el-form-item label="听说渠道" prop="referralSource">{{detailDialog.data.referralSource}}</el-form-item>
                <el-form-item label="手机号：" prop="phone">{{detailDialog.data.phone}}</el-form-item>
                <el-form-item label="头像：" prop="headerUrl">
                    <img style="height:90px" :src="detailDialog.data.headerUrl" />
                </el-form-item>
                <el-form-item label="密码：" prop="password">--</el-form-item>
                <el-form-item label="姓名：" prop="realName">{{detailDialog.data.realName}}</el-form-item>
                <el-form-item label="性别：" prop="sex">{{detailDialog.data.sex | sexFilter}}</el-form-item>
                <el-form-item label="邮箱：" prop="email">{{detailDialog.data.email}}</el-form-item>
                <el-form-item label="学历：" prop="education">{{detailDialog.data.education}}</el-form-item>
                <el-form-item label="所在省份：" prop="province">
                    {{detailDialog.data.provinceName}}{{detailDialog.data.cityName}}{{detailDialog.data.districtName}}
                </el-form-item>
                <el-form-item label="QQ：" prop="qq">{{detailDialog.data.qq}}</el-form-item>
                <el-form-item label="收货地址：" prop="consigneeAddress">{{detailDialog.data.consigneeAddressAll}}</el-form-item>
                <el-form-item label="护照姓：" prop="passportFirstName">{{detailDialog.data.passportFirstName}}</el-form-item>
                <el-form-item label="护照名：" prop="passportLastName">{{detailDialog.data.passportLastName}}</el-form-item>
                <el-form-item label="国籍：" prop="nationalityZh">{{detailDialog.data.nationalityZh}}</el-form-item>
                <el-form-item prop="birthday" label="生日：" v-if="loginOrgCode == 'blcuonline'">{{detailDialog.data.birthday | dateFormatFilter}}</el-form-item>
                <el-form-item prop="agentDes" label="生源：" v-if="loginOrgCode == 'blcuonline'">{{detailDialog.data.agentDes}}</el-form-item>
                <el-form-item prop="createTime" label="注册日期："   :formatter="createTimeFormat">{{detailDialog.data.createTime | dateFormatFilter1}}</el-form-item>
                <el-form-item label="现居地：" prop="address">{{detailDialog.data.address}}</el-form-item>
                
            </el-form>
        </el-dialog>
        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" :inline="true">
                        <el-form-item label="用户名" v-if="showSearch.userName" prop="userName" style="width: 15%">
                            <el-input v-model="searchData.userName" placeholder="用户名" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="phone" v-if="showSearch.phone" style="width: 15%" >
                            <el-input v-model="searchData.phone" placeholder="手机号" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名" prop="realName" v-if="showSearch.realName" style="width: 15%">
                            <el-input v-model="searchData.realName" placeholder="姓名" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email" v-if="showSearch.email" style="width: 15%">
                            <el-input v-model="searchData.email" placeholder="邮箱" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="QQ" prop="qq" v-if="showSearch.qq" style="width: 15%">
                            <el-input v-model="searchData.qq" placeholder="QQ" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="组织机构" prop="orgCode" v-if="showSearch.orgCode">
                            <el-select
                                placeholder="组织机构"
                                clearable
                                size="small"
                                v-model="searchData.orgCode"
                                @change="changeSearchOrg"
                                style="margin-right: 10px; width: 100%"
                            >
                                <el-option
                                    v-for="o in org"
                                    :label="o.organizationName"
                                    :value="o.orgCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="生源" v-if="showSearch.originSource" clearable prop="originSource">
                            <el-select
                                v-model="searchData.originSource"
                                clearable
                                placeholder="生源"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                v-for="item in agentsList"
                                :key="item.agentCode"
                                :label="item.agentDes"
                                :value="item.agentCode"
                            ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="来源" v-if="showSearch.source" clearable prop="source">
                            <el-select
                                v-model="searchData.source"
                                clearable
                                placeholder="来源"
                                size="small"
                                @change="changeSearchOrg"
                                style="width: 100%"
                            >
                                <el-option label="批量导入" :value="16"></el-option>
                                <el-option label="单个添加" :value="8"></el-option>
                                <el-option label="用户注册" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="批次" v-if="showSearch.banch" prop="banch" >
                                <el-select
                                    placeholder="批次"
                                    size="small"
                                    clearable
                                    v-model="searchData.banch"
                                    :disabled="!isBanch"
                                    style="margin-right: 10px; width: 100%"
                                >
                                    <el-option v-for="banch in orgBanchList" :label="banch" :value="banch"></el-option>
                                </el-select>
                        </el-form-item>
                        <el-form-item label="状态" v-if="showSearch.status" clearable prop="status">
                            <el-select
                                v-model="searchData.status"
                                clearable
                                placeholder="状态"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option label="正常" :value="1"></el-option>
                                <el-option label="停用" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    <el-form-item label="注册日期" v-if="showSearch.createTime" clearable prop="createTime">
                        <el-date-picker
                            v-model="searchData.createTimeStart"
                            type="date"
                            placeholder="起始日期"
                            value-format="yyyy-MM-dd"
                            size="small"
                        />
                        <span> 至 </span>
                        <el-date-picker
                            v-model="searchData.createTimeEnd"
                            type="date"
                            placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            size="small"
                        />
                    </el-form-item>
                <br>
                <el-form-item>
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-search"
                        @click="onSubmit()"
                    >查询</el-button>
                </el-form-item>
            </el-form>
            <el-button
                type="success"
                icon="el-icon-circle-plus-outline"
                size="small"
                round
                @click="addStaff = true,title='添加学生',isUpdate=false"
                class="but-cls"
            >添加</el-button>
            <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                round
                @click="deleteMore"
                class="but-cls"
            >删除</el-button>
            <el-button
                type="success"
                icon="el-icon-upload"
                size="small"
                round
                @click="showImport=true"
                class="but-cls"
            >导入</el-button>
            <el-button
                type="success"
                icon="el-icon-download"
                size="small"
                round
                @click="download"
                class="but-cls"
            >导出</el-button>
            <el-table
                :data="staffData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <!--序号、用户名、护照名、性别、国籍、生日、手机号、生源【指的是我们部门的合作机构，这个我们可以先手动填】、状态。-->
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
                <el-table-column prop="referralSource" label="听说渠道" width="150"></el-table-column>
                <el-table-column prop="userName" label="用户名" width="250" fixed="left" ></el-table-column>
                <el-table-column prop="passportLastName" label="护照名" width="165"  v-if="loginOrgCode == 'blcuonline'" :formatter="f_passportName"></el-table-column>
                <el-table-column prop="sex" label="性别" width="68"  :formatter="sexFormatter" v-if="loginOrgCode == 'blcuonline'"></el-table-column>
                <el-table-column prop="nationalityZh" label="国籍" width="90" v-if="loginOrgCode == 'blcuonline'"></el-table-column>
                <el-table-column prop="birthday" label="生日" width="115"  v-if="loginOrgCode == 'blcuonline'"  :formatter="date_formatter"></el-table-column>
                <el-table-column prop="orgName" label="组织机构" width="200" v-if="loginOrgCode != 'blcuonline'"></el-table-column>
                <el-table-column prop="phone" label="手机号" width="175"></el-table-column>
                <el-table-column prop="agentDes" label="生源" width="160"  v-if="loginOrgCode == 'blcuonline'"></el-table-column>
                <el-table-column prop="realName" label="姓名" width="100" v-if="loginOrgCode != 'blcuonline'"></el-table-column>
                <el-table-column prop="email" label="邮箱" width="200" v-if="loginOrgCode != 'blcuonline'"></el-table-column>
                <el-table-column prop="qq" label="QQ" width="100" v-if="loginOrgCode != 'blcuonline'"></el-table-column>
                <el-table-column prop="source" label="来源" v-if="loginOrgCode != 'blcuonline'" width="100" :formatter="sourceFormat"></el-table-column>
                <el-table-column prop="createTime" label="注册时间"  width="160" :formatter="createTimeFormat"></el-table-column>
                <el-table-column prop="banch" label="批次" width="120" v-if="loginOrgCode != 'blcuonline'"></el-table-column>
                <el-table-column prop="status" label="状态" width="61">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="2"
                            @change="updateUserState(scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="230">
                    <template slot-scope="scope">
                        <el-button
                            @click="seeDetail(scope.$index, scope.row)"
                            type="text"
                            size="small"
                        >查看详情</el-button>
                        <el-button
                            @click="restPWD(scope.$index, scope.row)"
                            type="text"
                            size="small"
                        >重置密码</el-button>
                        <el-button
                            @click="updateStaff(scope.$index, scope.row)"
                            type="text"
                            size="small"
                        >修改</el-button>
                        <el-button
                            @click="deleteStaff(scope.$index, scope.row)"
                            type="text"
                            size="small"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px"
            ></el-pagination>
        </el-main>
    </el-container>
</template>

<script>
import https from '@/https.js';
import validate from '@/api/validate.js';
import {dateFormat} from '@/api/utils.js';
const form = {
    orgCode: '',
    userName: '',
    phone: '',
    realName: '',
    sex: 0,
    birthday: '',
    originSource: '',
    email: '',
    education: '',
    province: '',
    city: '',
    district: '',
    qq: '',
    passportFirstName: '',
    passportLastName: '',
    address: '',
    password: '',
    confirmPassword: ''
};
const importStudentForm = {
    orgCode: '',
    banch: '',
    file: null
};
export default {
    data() {
        return {
          agentsList: [],
          checkList: ["userName", "orgCode", "originSource", "source", "banch"],
          showSearch: {
            userName: true,
            phone: false,
            realName: false,
            orgCode: true,
            status: false,
            email: false,
            source: true,
            originSource: true,
            banch: true,
            qq: false,
            createTime: false,
          },
          createTime: '',
            loginOrgCode: '',
            headerData: {Authentication: localStorage.getItem('token')},
            nationalityList: [],
            org: [],
            isBanch: false,
            orgType: '',
            orgCode: '',
            loading: true,
            form: JSON.parse(JSON.stringify(form)),
            searchData: {
                userName: '',
                phone: '',
                realName: '',
                orgCode: '',
                status: '',
                email: '',
                source: '',
                banch: '',
              originSource: '',
                qq: '',
                createTimeStart: '',
                createTimeEnd: '',
                page: 1,
                size: 0
            },
            multipleSelection: [],
            orgBanchList: [],
            banchList: [],
            rules: {
                userName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                    {validator: validate.validateUserName, trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '请输入电话', trigger: 'blur'},
                    {validator: validate.validatePhone, trigger: 'blur'}
                ],
                orgCode: [{required: true, message: '请选择机构', trigger: 'blur'}],
                password: [{validator: validate.validatePassword, trigger: 'blur'}],
                realName: [{max: 50, message: '长度不得超过50个字符', trigger: 'blur'}],
                email: [{validator: validate.validateEmail, trigger: 'blur'}],
                qq: [{validator: validate.validateQQ, trigger: 'blur'}],
                  passportFirstName: [
                    {max: 50, message: '长度不得超过100个字符', trigger: 'blur'}
                  ],
              passportFirstName: [
                {max: 50, message: '长度不得超过100个字符', trigger: 'blur'}
              ],
              address: [
                // {max: 100, message: '长度不得超过100个字符', trigger: 'blur'}
              ]
            },
            rulesImpoort: {
                orgCode: [{required: true, message: '请选择机构', trigger: 'change'}],
                banch: [{required: true, max: 50, message: '请输入：长度不得超过50个字符', trigger: 'blur'}],
                file: [{required: true, message: '请选择文件', trigger: 'change'}]
            },
            total: 0,
            pageSize: 10,
            currentPage: 1,
            addStaff: false,
            staffData: [],
            isUpdate: false,
            title: '添加用户',
            area: [],
            city: [],
            district: [],
            showImport: false,
            fileList: [],
            importStudentForm: {
                orgCode: '',
                banch: '',
                file: null
            },
            uploadUrl: this.https.baseURL + '/managerStudent/importStudent',
            isShowChooseBtn: true,
            detailDialog: {
                show: false,
                data: {
                    orgName: '北京语言大学继续教育学院'
                }
            }
        };
    },
    methods: {
      searchChange(a,b) {
        for(let key in this.showSearch) {
          this.showSearch[key] = false;
        }
        
        for(let checked of this.checkList) {
          this.showSearch[checked] = true;
        }
      },
      createTimeFormat(row, column, cellValue, index) {
        if(cellValue) {
          return dateFormat(cellValue).substr(0,16);
        }
      },
      sexFormatter (row, column, cellValue, index) {
        if(cellValue == 0) {
          return '保密';
        }
        if(cellValue == 1) {
          return '女';
        }
        if(cellValue == 2) {
          return '男';
        }
      },
      date_formatter(row, column, cellValue, index) {
        if(cellValue != null) {
          return dateFormat(cellValue).substr(0,10);
        } else {
          return cellValue;
        }
      },
        conformPassword(rule, value, callback) {
            if (this.form.password == value) {
                callback();
            } else {
                callback(new Error('两次密码输入不一致'));
            }
        },
        updateUserState(row) {
            if (row == undefined) {
                this.$message({
                    type: 'info',
                    message: '操作失败'
                });
            }

            let params = {
                userName: row.userName,
                status: row.status
            };
            this.https
                .fetchPost('/managerStudent/updateUserState', params, 'json')
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败:' + msg
                        });
                        if (row.status == 1) {
                            row.status = 2;
                        } else {
                            row.status = 1;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error('网络错误');
                    if (row.status == 1) {
                        row.status = 2;
                    } else {
                        row.status = 1;
                    }
                });
        },
        handleDialogClose() {
            let that = this;
            that.form = JSON.parse(JSON.stringify(form));
            that.form.sex = 0;
            that.addStaff = false;
            that.isUpdate = false;
            that.form.userId = '';
            that.$refs['staffForm'].clearValidate();
        },
      changeSearchOrg() {
          let orgCode = '';
          this.orgBanchList = [];
          this.searchData.banch = '';
          this.isBanch = false;
          if(this.searchData.source == 16) {
            this.isBanch = true;
          }
          if(this.searchData.orgCode && this.searchData.source == 16) {
            orgCode = this.searchData.orgCode;
          }
        if(this.orgType != 1 && this.searchData.source == 16) {
          orgCode = this.orgCode;
        }
        for(let banch of this.banchList) {
          if(banch.orgCode == orgCode) {
            this.orgBanchList = banch.banchList;
            return;
          }
        }
        },
        selectOrg() {
            https
                .fetchGet('/managerOrganization/getOrganizationList', '', 'from')
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.org = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error('网络错误');
                });
        },
        handleSelectionChange(val) {
            this.multipleSelection = [];
            for (let index in val) {
                this.multipleSelection[index] = val[index].userName;
            }
        },
        restPWD(index, row) {
            this.$confirm('此操作将重置该用户信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let params = row;
                    https
                        .fetchPost('/ssoUser/resetPassword', params, 'json')
                        .then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '重置成功!'
                                });
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '重置失败:' + msg
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message.error('网络异常！');
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
        },
        deleteMore() {
            let roleLength = this.multipleSelection.length;
            this.$confirm('此操作将删除' + roleLength + '条用户信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let multipleSelection = this.multipleSelection;
                    let params = {
                        userNameList: multipleSelection
                    };
                    https
                        .fetchPost('/managerStudent/deleteUser', params, 'json')
                        .then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.onSubmit();
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '删除失败:' + msg
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message.error('网络异常！');
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        deleteStaff(index, row) {
            this.$confirm('此操作将删除该用户信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let params = {
                        userNameList: [row.userName]
                    };
                    https
                        .fetchPost('/managerStudent/deleteUser', params, 'json')
                        .then((data) => {
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.onSubmit();
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '删除失败:' + msg
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message.error('网络异常！');
                        });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        onSubmit(val) {
            if (val) {
                this.searchData.page = val;
            } else {
                this.searchData.page = 1;
                this.currentPage = 1;
            }
            this.searchData.size = this.pageSize;
            let params = this.searchData;
            this.loading = true;
            https
                .fetchPost('/managerStudent/search', JSON.parse(JSON.stringify(params)), 'json')
                .then((data) => {
                    let code = data.data.code;
                    if (code == '200') {
                        this.staffData = data.data.data;
                        this.total = data.data.total;
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error('数据加载失败');
                });
        },
        handleSizeChange() {},
        handleCurrentChange(val) {
            this.onSubmit(val);
        },
        updateStaff(index, row) {
            this.title = '修改学生';
            console.log(row);
            if (row.province) {
                this.changeProvince(row.province);
            }
          if (row.city) {
            this.changeCity(row.city);
          }
            this.form = JSON.parse(JSON.stringify(row));
            this.addStaff = true;
            this.isUpdate = true;
        },
        saveStaff(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$message.error('请正确填写信息！');
                    return false;
                } else {
                    let url = '/managerStudent/addUser';
                    if (this.form.userId) {
                        url = '/managerStudent/updateUser';
                    }
                    let params = this.form;
                    https
                        .fetchPost(url, params)
                        .then((data) => {
                            console.log(data);
                            let code = data.data.code;
                            let msg = data.data.msg;
                            if (code == '200') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.addStaff = false;
                                this.isUpdate = false;
                                this.onSubmit();
                                this.form = JSON.parse(JSON.stringify(form));
                            } else {
                                this.$message.error('操作失败:' + msg);
                            }
                        })
                        .catch((err) => {
                            this.$message.error('网络错误');
                        });
                }
            });
        },
        staffStatus(row, column, cellValue, index) {
            if (cellValue == 1) {
                //（1 正常，2停用，3锁定）
                return '正常';
            }
            if (cellValue == 2) {
                return '停用';
            }
            if (cellValue == 2) {
                return '锁定';
            }
            return '其他';
        },
        staffSex(row, column, cellValue, index) {
            if (cellValue == 1) {
                //（性别(0 未知；1女；2男)
                return '女';
            }
            if (cellValue == 2) {
                return '男';
            }

            return '未知';
        },
        searchArea() {
            https
                .fetchGet('/managerAreas/getAreaTree', '', 'form')
                .then((data) => {
                    let code = data.data.code;
                    if (code == '200') {
                        this.area = data.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error('数据加载失败');
                });
        },
        changeOrgAdd(val) {},
        changeProvince(val) {
            this.city = [];
            this.form.city = '';
            this.form.district = '';
            let nowProvince = this.area.find((t) => t.code == val);
            this.city = nowProvince.children;
        },
        changeCity(val) {
            this.district = [];
            this.form.district = '';
            let nowCity = this.city.find((t) => t.code == val);
            this.district = nowCity.children;
        },
        handleStudentClose() {
            this.resetUploadInfo();
        },
        sourceFormat(row, column, cellValue, index) {
            if (cellValue != null) {
                let result = '';
                switch (cellValue) {
                    case 16:
                        result = '批量导入';
                        break;
                    case 8:
                        result = '单个添加';
                        break;
                    case 1:
                        result = '用户注册';
                        break;
                    case 2:
                        result = '用户注册';
                        break;
                }
                return result;
            } else {
                return cellValue;
            }
        },
        //region 导入
        changeImportOrgCode(val) {},
        importStudent() {},
        isShowUploadButton(isShow) {
            if (isShow) {
                this.isShowChooseBtn = true;
                //$(".upload-demo>.el-upload").show();
            } else {
                this.isShowChooseBtn = false;
                //$(".upload-demo>.el-upload").hide();
            }
        },
        beforeAvatarUpload(file) {
            let fileName = file.name;
            let pos = fileName.lastIndexOf('.');
            let lastName = fileName.substring(pos, fileName.length);
            let isExcel = true;
            if (lastName.toLowerCase() !== '.xlsx' && lastName.toLowerCase() !== '.xls') {
                this.$message.error('请上传Excel文件');
                // this.resetCompressData()
                isExcel = false;
            }
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isExcel) {
                this.$message.error('请上传Excel文件!');
            }
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 5MB!');
            }
            return isExcel && isLt2M;
        },
        selectUploadfile(file, fileList) {
            if (fileList.length > 0) {
                this.importStudentForm.file = file;
                this.isShowChooseBtn = false;
            } else {
                this.importStudentForm.file = null;
                this.isShowChooseBtn = true;
            }
        },
        removeFile() {
            this.isShowChooseBtn = true;
            this.importStudentForm.file = null;
        },
        uploadSuccess(res, file, fileList) {
            // 上传成功
            console.log(res);
            if (res.code == 200) {
                this.$message.success('上传成功');
                this.showImport = false;
            } else {
                this.$message.error(res.msg); //上传失败时提示失败原因
                this.showImport = true;
            }
            this.resetUploadInfo();
            //刷新
            this.onSubmit();
        },
        uploadError(err) {
            // 上传失败
            this.$message.error('上传失败');
            this.resetUploadInfo();
        },
        submitImport(formName) {
            if (this.orgType == 1 && !this.importStudentForm.orgCode) {
                this.$message.error('请选择所属机构');
                return false;
            }
            if (!this.importStudentForm.banch) {
                this.$message.error('请输入批次');
                return false;
            }
            if (!this.importStudentForm.file) {
                this.$message.error('请选择文件');
                return false;
            }
            if (this.importStudentForm.banch.length > 50) {
                this.$message.error('批次的长度不能超过50');
                return false;
            }
            this.$refs.upload.submit();
        },
        resetUploadInfo() {
            this.isShowChooseBtn = true;
            this.showImport = false;
            this.$refs.upload.clearFiles();
            this.importStudentForm = JSON.parse(JSON.stringify(importStudentForm));
            this.$nextTick(() => {
                this.$refs['importStudentForm'].clearValidate();
            });
        },
        //endregion 导入

        //region 导出
        download() {
            // if (!this.multipleSelection || this.multipleSelection.length < 1) {
            //     this.$message.error('请选择要导出的记录');
            //     return;
            // }

            // let params = {
            //     userNameList: this.multipleSelection
            // };
            let params = this.searchData;
            https
                .fetchPost('/managerStudent/downloadStudentExcel', params, 'json', '', 'blob')
                .then((res) => {
                    let fileName = '学生管理.xls';
                    let type = res.headers['content-type'];
                    let blob = new Blob([res.data], {type: type});

                    if (window.navigator.msSaveBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        const elink = document.createElement('a');
                        elink.download = fileName;
                        elink.style.display = 'none';
                        elink.href = window.URL.createObjectURL(new Blob([res.data]));
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    }
                })
                .catch(() => {
                    this.$message.error('下载附件失败，请联系管理员');
                });
        },
        //endregion

        //region 详情
        //详情
        seeDetail(index, row) {
            let params = {
                userName: row.userName
            };
            this.detailDialog.data = {};
            let that = this;
            https
                .fetchPost('/managerStudent/findUser', params, 'json')
                .then((res) => {
                    let code = res.data.code;
                    let msg = res.data.msg;
                    if (code == 200) {
                      if(res.data.data[0]) {
                        this.detailDialog.data = res.data.data[0];
                      }
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }
                })
                .catch(() => {
                    this.$message.error('网络错误，请联系管理员');
                });

            this.detailDialog.show = true;
        },
        handleDetailClose() {
            this.detailDialog.show = false;
        },
      // /managerNationality/getList
      getNationality() {
        https.fetchGet('/managerNationality/getList', {}, 'form').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data) {
              this.nationalityList = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        })
            .catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
            });
      },
      f_passportName(row, column, cellValue, index) {
        if(!row.passportFirstName) {
          row.passportFirstName = "";
        }
        if(!row.passportLastName) {
          row.passportLastName = "";
        }
        return row.passportFirstName + " " +row.passportLastName;
      },
      selectBanch() {
        let params = {
          orgCode: '',
          source: ''
        };
        https.fetchPost('/managerStudent/getBanchList', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                if(data.data.data) {
                  this.banchList = data.data.data;
                }
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
            });
      },
      searchAgents() {
        let params = {
        };
        this.https.fetchPost('/managerRole/agents', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.agentsList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      addRule(prop, rule) {
        this.$set(this.rules, prop, rule);
      },
        //endregion 详情
    },
  filters: {
    dateFormatFilter(val) {
      return dateFormat(val).substr(0,10);
    },
    dateFormatFilter1(val) {
      return dateFormat(val).substr(0,16);
    },
    sexFilter(val) {
      if(val == 0) {
        return '保密';
      }
      if(val == 1) {
        return '女';
      }
      if(val == 2) {
        return '男';
      }
    }
  },
  watch: {
    'loginOrgCode': {
      immediate: true,
      handler (newVal) {
        if (this.loginOrgCode == 'blcuonline') {
          this.addRule('userName', [{ required: true, message: '请输入用户名', trigger: 'blur' }]);
          this.addRule('phone', []);
          this.addRule('email', [{ required: true, message: '请输入邮箱', trigger: 'blur' },{validator: validate.validateEmail, trigger: 'blur'}]);
        } else {
          this.addRule('userName', [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            {validator: validate.validateUserName, trigger: 'blur'}
          ]);
          this.addRule('phone', [
            {required: true, message: '请输入电话', trigger: 'blur'},
            {validator: validate.validatePhone, trigger: 'blur'}
          ]);
          this.addRule('email', [{validator: validate.validateEmail, trigger: 'blur'}],);
          
        }

      }
    },
  },
  created: function () {
        this.loginOrgCode = this.$store.state.orgCode;
        this.orgType = this.$store.state.orgType;
        this.orgCode = this.$store.state.orgCode;
        this.onSubmit();
        this.searchArea();
        this.selectOrg();
        this.selectBanch();
        this.getNationality();
        this.searchAgents();
    }
};
</script>

<style scoped>
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
#detailDialog .el-form-item {
    margin-bottom: 0;
}
    .line {
        text-align: center;
    }
</style>
